import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Box, Card, makeStyles, Container, CardHeader, Button, CardContent, Typography, DialogContentText, Divider, MenuItem, Grid, InputLabel, TextField, TableCell, TableRow, TableContainer, TableBody, Table, TableHead, Chip, Switch, CircularProgress } from '@material-ui/core';
import Page from 'src/components/Page';
import PageHeader from 'src/views/Common/PageHeader';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import { LoadingComponent } from '../../../utils/newLoader';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import DeleteIcon from '@material-ui/icons/Delete';
import tokenService from '../../../utils/tokenDecoder';
import tokenDecoder from '../../../utils/tokenDecoder';
import { useParams } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { use } from 'react';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    table: {
        minWidth: 550,
    },
}));

const screenCode = "SKUMASTER"
export default function SKUMasterAddEdit() {
    const classes = useStyles();
    const navigate = useNavigate();
    const alert = useAlert();
    const [title, setTitle] = useState("Add SKU Details ")
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [skuTypes, setSkuTypes] = useState();
    const [skuCategory, setSkuCategory] = useState();
    const [measuringUnitData, setMeasuringUnitData] = useState();
    const [isUpdate, setIsUpdate] = useState(false);
    const [ArrayField, setArrayField] = useState([]);
    const [sKUMasterCode, setSKUCode] = useState("");
    const [lastSequence, setLastSequence] = useState(null);
    const [skuPrefix, setSkuPrefix] = useState(null);
    const [backConfirmation, setBackConfirmation] = useState(false);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [deleteYesDisable, setDeleteYesDisable] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [addConfirmation, setAddConfirmation] = useState(false);
    const [updateArrayField, setupdateArrayField] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);
    const [categorySequences, setCategorySequences] = useState({});
    const [saveArrayField, setSaveArrayField] = useState([]);
    const [isAdd, setIsAdd] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const [skuDetails, setSkuDetails] = useState({
        groupID: 0,
        factoryID: 0,
        sKUTypeID: 0,
        sKUTypeName: '',
        sKUCategoryID: 0,
        sKUCategoryName: '',
        measuringUnitID: 0,
        measuringUnitName: '',
        sKUMasterCode: '',
        sKUMasterName: '',
        minLevel: '',
        reOrderLevel: '',
        maxLevel: '',
        sKUMasterDescription: '',
        isActive: true
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
    });

    const { skuMasterID } = useParams();

    let decrypted = 0

    useEffect(() => {
        decrypted = atob(skuMasterID);
        if (parseInt(decrypted) !== 0) {
            setIsUpdate(true);
            getDetailsBySKUMasterID(decrypted);
        }
    }, []);

    useEffect(() => {
        if (skuDetails.groupID > 0 && skuDetails.sKUCategoryID > 0) {
            generateSKUCode(skuDetails.groupID, skuDetails.sKUCategoryID);
        }
    }, [skuDetails.groupID, skuDetails.sKUCategoryID]);

    const amountRef = useRef(null);
    const descriptionRef = useRef(null);
    const recordCount = ArrayField.length;

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermissions(), getSKUTypesForDropdown(), getMeasuringUnitsForDropdown());
    }, []);

    // useEffect(() => {
    //     if (skuDetails.groupID != 0 && skuDetails.factoryID != 0) {
    //         trackPromise(
    //             getSKUTCategoriesForDropdown(skuDetails.groupID, skuDetails.factoryID)
    //         );
    //     } else {
    //         setSkuDetails(prev => ({
    //             ...prev,s
    //             skUCategoryID: 0
    //         }));
    //         setSkuCategory([]);
    //     }
    // }, [skuDetails.groupID, skuDetails.factoryID])

    useEffect(() => {
        if (skuDetails.groupID != 0 && skuDetails.factoryID != 0 && skuDetails.sKUTypeID != 0) {
            trackPromise(
                getSKUTCategoriesDropdown(skuDetails.groupID, skuDetails.factoryID ,skuDetails.sKUTypeID)
            );
        } else {
            setSkuDetails(prev => ({
                ...prev,
                sKUCategoryID: 0
            }));
            setSkuCategory([]);
        }
    }, [skuDetails.groupID, skuDetails.factoryID, skuDetails.sKUTypeID])


    useEffect(() => {
        if (skuDetails.groupID !== 0) {
            setSkuDetails(prev => ({
                ...prev,
                skUCategoryID: 0
            }));
            setSkuCategory();
        }
    }, [skuDetails.groupID])

    useEffect(() => {
        if (skuDetails.sKUTypeID == 0) {
            setSkuDetails((prev) => ({
                ...prev,
                sKUCategoryID: 0
            }))
            setSkuCategory()
        }
    }, [skuDetails.sKUTypeID])

    useEffect(() => {
        if (skuDetails.groupID != 0) {
            trackPromise(
                getFactoriesForDropdown(skuDetails.groupID)
            );
        }
    }, [skuDetails.groupID])

    useEffect(() => {
        if (!isUpdate) {
            setSkuDetails({
                ...skuDetails,
                groupID: 0,
                factoryID: 0,
                sKUMasterCode: '',
                reOrderLevel: '',
                maxLevel: '',
                sKUMasterDescription: '',
                sKUTypeID: 0,
                sKUTypeName: '',
                sKUCategoryID: 0,
                sKUCategoryName: '',
                measuringUnitID: 0,
                measuringUnitName: '',
                sKUMasterName: '',
                minLevel: '',
                isActive: true
            })
        }
    }, [])

    const handleClick = () => {
        navigate('/app/skuMaster/listing');
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITSKUMATER');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setSkuDetails({
            ...skuDetails,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken()),
        })
    }

    function clearData() {
        setSkuDetails({
            ...skuDetails,
            sKUMasterCode: '',
            reOrderLevel: '',
            maxLevel: '',
            sKUMasterDescription: '',
            sKUTypeID: 0,
            sKUTypeName: '',
            sKUCategoryID: 0,
            sKUCategoryName: '',
            measuringUnitID: 0,
            measuringUnitName: '',
            sKUMasterName: '',
            minLevel: '',
            isActive: true
        });
        setSKUCode([]);
        setSkuCategory([]);
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }

    async function getFactoriesForDropdown(groupID) {
        const factories = await services.getAllFactoriesByGroupID(groupID);
        setFactories(factories);
    }

    async function getSKUTypesForDropdown() {
        const skuTypes = await services.GetSKUTypes();
        setSkuTypes(skuTypes);
    }

    // async function generateSKUCode(groupID, skuCategoryID) {
    //     const model = {
    //         groupID: parseInt(groupID),
    //         skuCategoryID: parseInt(skuCategoryID)
    //     };
    //     let skuCode;

    //     if (lastSequence === null || skuCategoryID !== skuDetails.sKUCategoryID) {
    //         skuCode = await services.GenerateSKUCode(model);
    //         const sequence = parseInt(skuCode.slice(-4), 10);
    //         const prefix = skuCode.slice(0, -4);
    //         setLastSequence(sequence);
    //         setSkuPrefix(prefix);
    //     } else {
    //         const nextSeq = lastSequence + 1;
    //         skuCode = skuPrefix + String(nextSeq).padStart(4, "0");
    //         setLastSequence(nextSeq);
    //     }
    //     setSKUCode(skuCode);
    // }


    async function generateSKUCode(groupID, skuCategoryID) {
        const model = {
            groupID: parseInt(groupID),
            skuCategoryID: parseInt(skuCategoryID)
        };

        let skuCode;
        const categoryKey = `${groupID}-${skuCategoryID}`;

        if (!categorySequences[categoryKey]) {
            skuCode = await services.GenerateSKUCode(model);
            const sequence = parseInt(skuCode.slice(-4), 10);
            const prefix = skuCode.slice(0, -4);

            setCategorySequences(prev => ({
                ...prev,
                [categoryKey]: {
                    sequence,
                    prefix
                }
            }));
            setLastSequence(sequence);
            setSkuPrefix(prefix);
        } else {
            const { sequence, prefix } = categorySequences[categoryKey];
            const nextSeq = sequence + 1;
            skuCode = prefix + String(nextSeq).padStart(4, "0");

            setCategorySequences(prev => ({
                ...prev,
                [categoryKey]: {
                    sequence: nextSeq,
                    prefix
                }
            }));
            setLastSequence(nextSeq);
            setSkuPrefix(prefix);
        }

        setSKUCode(skuCode);
    }

    async function getSKUTCategoriesDropdown(groupID, factoryID ,sKUTypeID) {
        const SKUCategoryNames = await services.getSKUTCategoriesDropdown(groupID, factoryID , sKUTypeID);
        setSkuCategory(SKUCategoryNames);
    }

    async function getMeasuringUnitsForDropdown() {
        const measuringUnitData = await services.GetMeasuringUnits();
        setMeasuringUnitData(measuringUnitData);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function handleChange(e) {
        const target = e.target;
        const name = target.name;
        const value = target.type === "checkbox" ? target.checked : target.value;

        if (name === "sKUCategoryID") {
            const prevCategory = skuDetails.sKUCategoryID;
            setSkuDetails((prevDetails) => ({
                ...prevDetails,
                [name]: value,
            }));

            if (parseInt(value) !== prevCategory) {
                setSKUCode("");
                setLastSequence(null);
                setSkuPrefix(null);
            }
        }
        else if (name === "sKUTypeID") {
            setSkuDetails((prevDetails) => ({
                ...prevDetails,
                [name]: value,
                sKUCategoryID: 0,
            }));
            setSKUCode("");
            setLastSequence(null);
            setSkuPrefix(null);
            setSkuCategory([]);
        } else {
            setSkuDetails((prevDetails) => ({
                ...prevDetails,
                [name]: value,
            }));
        }
    }

    function handleChangeNo(e) {
        const value = e.target.value.replace(/\s/g, "");
        setSKUCode(value);
    }

    function handleChangeForAmount(e) {
        const target = e.target;
        let value = target.value;

        value = value.replace(/[^0-9.]/g, '');
        const decimalParts = value.split('.');

        if (decimalParts.length > 2) {

            value = decimalParts.slice(0, 2).join('.');
        } else if (decimalParts.length === 2) {

            value = `${decimalParts[0]}.${decimalParts[1].slice(0, 2)}`;
        }

        setSkuDetails({
            ...skuDetails,
            [target.name]: value
        });
    }

    const handleKeyDown = (event, nextInputRef) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            nextInputRef.current.focus();
        }

        if (
            event.key !== "Backspace" &&
            event.key !== "Delete" &&
            event.key !== "Tab" &&
            event.key !== "ArrowLeft" &&
            event.key !== "ArrowRight" &&
            event.key !== "." &&
            (event.key < "0" || event.key > "9")
        ) {
            event.preventDefault();
        }

        if (event.key === "." && event.target.value.includes(".")) {
            event.preventDefault();
        }
    }

    async function addSKUDetails() {
        if (sKUMasterCode == null) {
            alert.error("Please enter SKU code");
            return;
        }

        const isDuplicate = ArrayField.some(x =>
            x.groupID === parseInt(skuDetails.groupID) &&
            x.factoryID === parseInt(skuDetails.factoryID) &&
            x.sKUTypeID === parseInt(skuDetails.sKUTypeID) &&
            x.sKUCategoryID === parseInt(skuDetails.sKUCategoryID) &&
            x.sKUMasterCode === sKUMasterCode &&
            x.sKUMasterName === skuDetails.sKUMasterName
        );

        const isDuplicateCode = ArrayField.some(x => x.sKUMasterCode === sKUMasterCode);

        if (isDuplicate) {
            alert.error("The record already exists!");
            return;
        }

        if (isDuplicateCode) {
            alert.error("SKU code already exists!");
            return;
        }

        let model = {
            groupID: parseInt(skuDetails.groupID),
            factoryID: parseInt(skuDetails.factoryID),
            sKUMasterCode: sKUMasterCode,
            reOrderLevel: skuDetails.reOrderLevel == '' ? 0 : parseFloat(skuDetails.reOrderLevel),
            budgetCodeID: parseInt(skuDetails.sKUTypeID),
            sKUCategoryID: skuDetails.sKUCategoryID,
            measuringUnitID: skuDetails.measuringUnitID,
            measuringUnitName: measuringUnitData[skuDetails.measuringUnitID],
            sKUMasterName: skuDetails.sKUMasterName,
            sKUMasterDescription: skuDetails.sKUMasterDescription,
            maxLevel: skuDetails.maxLevel == '' ? 0 : parseFloat(skuDetails.maxLevel),
            minLevel: skuDetails.minLevel == '' ? 0 : parseFloat(skuDetails.minLevel),
            isActive: skuDetails.isActive,
            createddBy: parseInt(tokenDecoder.getUserIDFromToken()),
        };
        let response = await services.findExistsRecord(model);
        if (response.data < 0) {
            alert.error(response.message);
            return;
        }
        let modelCode = {
            sKUMasterCode: sKUMasterCode,
        };

        if (!isUpdate) {
            const result = await services.GetSKUDataByTypeAndCategory(modelCode);

            if (result.data > 0) {
                alert.error(result.message);
                return;
            }
        }
        const isMatch = ArrayField.some(x =>
            x.groupID === parseInt(skuDetails.groupID) &&
            x.factoryID === parseInt(skuDetails.factoryID) &&
            x.budgetCodeID === parseInt(skuDetails.sKUTypeID) &&
            x.sKUMasterCode === sKUMasterCode &&
            x.sKUMasterName === skuDetails.sKUMasterName &&
            x.sKUCategoryID === parseInt(skuDetails.sKUCategoryID)
        );

        if (isMatch) {
            alert.error("The record already exists!");
        } else {
            var array1 = [...ArrayField];
            array1.push({
                groupID: parseInt(skuDetails.groupID),
                factoryID: parseInt(skuDetails.factoryID),
                sKUMasterCode: sKUMasterCode,
                reOrderLevel: skuDetails.reOrderLevel == '' ? null : parseFloat(skuDetails.reOrderLevel),
                maxLevel: skuDetails.maxLevel == '' ? null : parseFloat(skuDetails.maxLevel),
                sKUMasterDescription: skuDetails.sKUMasterDescription == '' ? null : skuDetails.sKUMasterDescription,
                budgetCodeID: parseInt(skuDetails.sKUTypeID),
                sKUCategoryID: parseInt(skuDetails.sKUCategoryID),
                sKUMasterName: skuDetails.sKUMasterName == '' ? null : skuDetails.sKUMasterName,
                minLevel: skuDetails.minLevel == '' ? null : parseFloat(skuDetails.minLevel),
                isActive: skuDetails.isActive,
                measuringUnitID: parseInt(skuDetails.measuringUnitID),
                createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
                skuMasterID: parseInt(atob(skuMasterID).toString()),
                sKUTypeName: skuTypes[skuDetails.sKUTypeID],
                sKUCategoryName: skuCategory[skuDetails.sKUCategoryID],
                measuringUnitName: measuringUnitData[skuDetails.measuringUnitID],
                createdDate: new Date().toISOString()
            });
            setArrayField(array1);
            setIsAdd(true);
            setSkuDetails({
                ...skuDetails,
                groupID: skuDetails.groupID,
                factoryID: skuDetails.factoryID,
                sKUTypeID: 0,
                sKUCategoryID: 0,
                measuringUnitID: 0,
                sKUMasterName: '',
                minLevel: '',
                reOrderLevel: '',
                sKUMasterCode: '',
                maxLevel: '',
                sKUMasterDescription: '',
                sKUCategoryID: 0,
            });
            setSKUCode([]);

            const categoryKey = `${skuDetails.groupID}-${skuDetails.sKUCategoryID}`;

            if (categorySequences[categoryKey]) {
                const { sequence, prefix } = categorySequences[categoryKey];
                setCategorySequences(prev => ({
                    ...prev,
                    [categoryKey]: {
                        sequence: sequence + 1,
                        prefix
                    }
                }));
            }

            const checkExistingData = selectedData.filter(
                (item) =>
                    item.groupID === parseInt(skuDetails.groupID) &&
                    item.factoryID === parseInt(skuDetails.factoryID) &&
                    item.sKUTypeID === parseInt(skuDetails.sKUTypeID) &&
                    item.sKUCategoryID === parseInt(skuDetails.sKUCategoryID) &&
                    item.sKUMasterCode === sKUMasterCode &&
                    item.sKUMasterName === skuDetails.sKUMasterName
            );

            if (checkExistingData.length > 0) {
                const updateDataArray = [...updateArrayField];
                updateDataArray.push({
                    groupID: parseInt(skuDetails.groupID),
                    factoryID: parseInt(skuDetails.factoryID),
                    sKUMasterCode: sKUMasterCode,
                    reOrderLevel: parseFloat(skuDetails.reOrderLevel),
                    maxLevel: parseFloat(skuDetails.maxLevel),
                    sKUMasterDescription: skuDetails.sKUMasterDescription,
                    budgetCodeID: parseInt(skuDetails.sKUTypeID),
                    sKUCategoryID: parseInt(skuDetails.sKUCategoryID),
                    measuringUnitID: parseInt(skuDetails.measuringUnitID),
                    measuringUnitName: measuringUnitData[skuDetails.measuringUnitID],
                    sKUMasterName: skuDetails.sKUMasterName,
                    minLevel: parseFloat(skuDetails.minLevel),
                    isActive: skuDetails.isActive,
                    createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
                });
                setupdateArrayField(updateDataArray);
            } else {
                const saveDataArray = [...saveArrayField];
                saveDataArray.push({
                    groupID: parseInt(skuDetails.groupID),
                    factoryID: parseInt(skuDetails.factoryID),
                    sKUMasterCode: sKUMasterCode,
                    reOrderLevel: parseFloat(skuDetails.reOrderLevel),
                    maxLevel: parseFloat(skuDetails.maxLevel),
                    sKUMasterDescription: skuDetails.sKUMasterDescription,
                    budgetCodeID: parseInt(skuDetails.sKUTypeID),
                    sKUCategoryID: parseInt(skuDetails.sKUCategoryID),
                    measuringUnitID: parseInt(skuDetails.measuringUnitID),
                    measuringUnitName: measuringUnitData[skuDetails.measuringUnitID],
                    sKUMasterName: skuDetails.sKUMasterName,
                    minLevel: parseFloat(skuDetails.minLevel),
                    isActive: skuDetails.isActive,
                    createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
                });
                setSaveArrayField(saveDataArray);
                setSkuCategory([]);
            }
        }
    }

    async function getDetailsBySKUMasterID(skuMasterID) {
        const skuData = await services.GetDetailsBySKUMasterID(skuMasterID);
        setIsUpdate(true);
        setSkuDetails({
            ...skuDetails,
            groupID: parseInt(skuData.groupID),
            factoryID: parseInt(skuData.factoryID),
            sKUTypeID: parseInt(skuData.skuTypeID),
            sKUCategoryID: parseInt(skuData.skuCategoryID),
            measuringUnitID: parseInt(skuData.measuringUnitID),
            sKUMasterCode: skuData.skuMasterCode,
            sKUMasterName: skuData.skuMasterName,
            maxLevel: parseFloat(skuData.maxLevel).toFixed(2),
            minLevel: parseFloat(skuData.minLevel).toFixed(2),
            reOrderLevel: parseFloat(skuData.reOrderLevel).toFixed(2),
            sKUMasterDescription: skuData.description,
            modifiedBy: parseInt(tokenDecoder.getUserIDFromToken()),
            createdBy: parseInt(skuData.createdBy),
            skuMasterID: parseInt(skuData.skuMasterID),
            modifiedDate: new Date().toISOString(),
            isActive: skuData.isActive,
            sKUCategoryName: skuData.skuCategoryName,
            measuringUnitName: skuData.measuringUnitName,
            sKUTypeName: skuData.skuTypeName,
        })

        setSKUCode(skuData.skuMasterCode);
        setTitle("Edit SKU Details");
    }

    async function saveDetails() {

        handleAddOpen();

        if (isUpdate) {
            let updateModel = {
                groupID: parseInt(skuDetails.groupID),
                factoryID: parseInt(skuDetails.factoryID),
                sKUMasterCode: sKUMasterCode,
                reOrderLevel: skuDetails.reOrderLevel == '' ? null : parseFloat(skuDetails.reOrderLevel),
                maxLevel: skuDetails.maxLevel === '' ? null : parseFloat(skuDetails.maxLevel),
                sKUMasterDescription: skuDetails.sKUMasterDescription === '' ? null : skuDetails.sKUMasterDescription,
                budgetCodeID: parseInt(skuDetails.sKUTypeID),
                sKUCategoryID: parseInt(skuDetails.sKUCategoryID),
                sKUMasterName: skuDetails.sKUMasterName === '' ? null : skuDetails.sKUMasterName,
                minLevel: skuDetails.minLevel === '' ? null : parseFloat(skuDetails.minLevel),
                isActive: skuDetails.isActive,
                measuringUnitID: parseInt(skuDetails.measuringUnitID),
                createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
                skuMasterID: parseInt(atob(skuMasterID).toString()),
                sKUTypeName: skuTypes[skuDetails.sKUTypeID],
                sKUCategoryName: skuCategory[skuDetails.sKUCategoryID],
                measuringUnitName: measuringUnitData[skuDetails.measuringUnitID],
                createdDate: new Date().toISOString()
            };
            let updateResponse = await services.UpdateSKUData(updateModel);

            if (updateResponse.statusCode === "Success") {
                alert.success(updateResponse.message);
                setArrayField([]);
                navigate('/app/skuMaster/listing');
            } else {
                alert.error(updateResponse.message);
            }
        } else {
            setSkuDetails({
                ...skuDetails,
                groupID: 0,
                factoryID: 0,
                sKUTypeID: 0,
                sKUCategoryID: 0,
                measuringUnitID: 0,
                sKUMasterName: '',
                minLevel: '',
                reOrderLevel: '',
                sKUMasterCode: '',
                maxLevel: '',
                sKUMasterDescription: '',
            });

            if (ArrayField.length > 0) {

                let saveResponse = await services.saveDetails(ArrayField);
                if (saveResponse.statusCode === "Success") {
                    alert.success(saveResponse.message);
                    setArrayField([]);
                    setSaveArrayField([]);
                    navigate('/app/skuMaster/listing');
                } else {
                    alert.error(saveResponse.message);
                }
            }
        }
    }


    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
                <Grid item md={2} xs={12}>
                    <PageHeader
                        onClick={handleConfirmBackOne}
                    />
                </Grid>
            </Grid>
        )
    }

    function handleAdd() {
        setAddConfirmation(false)
    }

    function handleAddOpen() {
        setAddConfirmation(true)
    }

    const handleAddOnChange = () => {
        if (isProcessing) return;
        setIsProcessing(true);
        saveDetails()
        setAddConfirmation(false);
        setTimeout(() => {
            setIsProcessing(false);
        }, 1000);
    }

    function handleDelete() {
        setDeleteConfirmation(false)
    }

    const handleDeleteOpen = (row, index) => {
        setSelectedRow({ row, index });
        setDeleteConfirmation(true);
    };


    function handleConfirmBackOne() {
        if (ArrayField.length != 0) {
            handleConfirmBackOpen()
        }
        else {
            handleClick()
        }
    }

    function handleConfirmBack() {
        setBackConfirmation(false);
        navigate('/app/skuMaster/listing');
    }

    const handleDialogClose = () => {
        setBackConfirmation(false)
    };

    function handleConfirmBackOpen() {
        setBackConfirmation(true)
    }

    const handleDeleteOnChange = () => {
        setDeleteYesDisable(true);
        setTimeout(() => {
            setDeleteYesDisable(false);
        }, 3000);

        if (selectedRow !== null) {
            const updatedArray = [...ArrayField];
            updatedArray.splice(selectedRow.index, 1);
            setArrayField(updatedArray);
        }
        setDeleteConfirmation(false);
    };

    return (
        <Fragment>
            <LoadingComponent />
            <Page
                className={classes.root}
                title={title}
            >
                <Container maxWidth={false}>

                    <Formik
                        initialValues={{
                            groupID: skuDetails.groupID,
                            factoryID: skuDetails.factoryID,
                            sKUTypeID: skuDetails.sKUTypeID,
                            reOrderLevel: skuDetails.reOrderLevel,
                            sKUMasterCode: sKUMasterCode,
                            sKUCategoryID: skuDetails.sKUCategoryID,
                            measuringUnitID: skuDetails.measuringUnitID,
                            sKUMasterName: skuDetails.sKUMasterName,
                            maxLevel: skuDetails.maxLevel,
                            sKUMasterDescription: skuDetails.sKUMasterDescription,
                            minLevel: skuDetails.minLevel,
                        }}

                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                                sKUTypeID: Yup.number().required('Account Code Name is required').min("1", 'Account Code Name is required'),
                                reOrderLevel: Yup.number()
                                    .required('Re-Order Level is required')
                                    .transform((value, originalValue) => (originalValue === '' ? null : value)).min(1, 'Re-Order Level cannot be 0')
                                    .test(
                                        'reOrderLevel-range',
                                        'Re-Order Level must be between Min Level and Max Level',
                                        function (value) {
                                            if (value == null) return true;
                                            const { minLevel, maxLevel } = this.parent;
                                            return (minLevel == null || value >= minLevel) && (maxLevel == null || value <= maxLevel);
                                        }
                                    ),
                                minLevel: Yup.number()
                                    .transform((value, originalValue) => (originalValue.trim() === '' ? null : value))
                                    .required('Min Level is required')
                                    .min(1, 'Min Level cannot be 0')
                                    .test(
                                        'minLevel-check',
                                        'Min Level must be less than or equal to Max Level & Re-Order Level',
                                        function (value) {
                                            const { maxLevel, reOrderLevel } = this.parent;
                                            if (value == null) return true;
                                            if (maxLevel != null && value > maxLevel) return false;
                                            if (reOrderLevel != null && value > reOrderLevel) return false;
                                            return true;
                                        }
                                    ),
                                maxLevel: Yup.number()
                                    .transform((value, originalValue) => (originalValue.trim() === '' ? null : value))
                                    .required('Max Level is required')
                                    .min(1, 'Max Level cannot be 0')
                                    .test(
                                        'maxLevel-check',
                                        'Max Level must be greater than or equal to Min Level & Re-Order Level',
                                        function (value) {
                                            const { minLevel, reOrderLevel } = this.parent;
                                            if (value == null) return true;
                                            if (minLevel != null && value < minLevel) return false;
                                            if (reOrderLevel != null && value < reOrderLevel) return false;
                                            return true;
                                        }
                                    ),
                                sKUMasterCode: Yup.string().required('SKU Code is required'),
                                sKUCategoryID: Yup.number().required('SKU Category is required').min("1", 'SKU Category is required'),
                                measuringUnitID: Yup.number().required('Measuring Unit is required').min("1", 'Measuring Unit is required'),
                                sKUMasterName: Yup.string()
                                    .required('SKU Name is required')
                                    .matches(/^\S.*\S$|^\S$/, 'Spaces are not allowed at start or end'),
                                sKUMasterDescription: Yup.string()
                                    .max(255, 'SKU Description must be at most 255 characters')
                                    .matches(/^\S.*\S$|^\S$|^$/, 'Spaces are not allowed at start or end')
                                    .nullable(),
                            })
                        }
                        onSubmit={() => trackPromise(addSKUDetails())}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(title)}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent style={{ marginBottom: "2rem" }}>
                                                <Grid container spacing={3}>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="groupID">
                                                            Group  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            helperText={touched.groupID && errors.groupID}
                                                            fullWidth
                                                            name="groupID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={skuDetails.groupID}
                                                            variant="outlined"
                                                            disabled={isUpdate}
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isGroupFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory  *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            fullWidth
                                                            name="factoryID"
                                                            onChange={(e) => handleChange(e)}
                                                            value={skuDetails.factoryID}
                                                            variant="outlined"
                                                            disabled={isUpdate}
                                                            size="small"
                                                            onBlur={handleBlur}
                                                            InputProps={{
                                                                readOnly: !permissionList.isFactoryFilterEnabled,
                                                            }}
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="sKUTypeID">
                                                            Account Code Name *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.sKUTypeID && errors.sKUTypeID)}
                                                            fullWidth
                                                            helperText={touched.sKUTypeID && errors.sKUTypeID}
                                                            name="sKUTypeID"
                                                            placeholder='--Select Account Code--'
                                                            onBlur={handleBlur}
                                                            size='small'
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={skuDetails.sKUTypeID}
                                                            variant="outlined"
                                                            id="sKUTypeID"
                                                            disabled={isUpdate}
                                                            inputProps={{
                                                                readOnly: isUpdate
                                                            }}
                                                        >
                                                            <MenuItem value={0}>--Select Account Code Name--</MenuItem>
                                                            {generateDropDownMenu(skuTypes)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="sKUCategoryID">
                                                            SKU Category *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.sKUCategoryID && errors.sKUCategoryID)}
                                                            fullWidth
                                                            helperText={touched.sKUCategoryID && errors.sKUCategoryID}
                                                            name="sKUCategoryID"
                                                            placeholder='--Select SKU Category--'
                                                            onBlur={handleBlur}
                                                            size='small'
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={skuDetails.sKUCategoryID}
                                                            variant="outlined"
                                                            id="sKUCategoryID"
                                                            disabled={isUpdate}
                                                            inputProps={{
                                                                readOnly: isUpdate
                                                            }}
                                                        >
                                                            <MenuItem value={0}>--Select SKU Category--</MenuItem>
                                                            {generateDropDownMenu(skuCategory)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="measuringUnitID">
                                                            Measuring Unit *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.measuringUnitID && errors.measuringUnitID)}
                                                            fullWidth
                                                            helperText={touched.measuringUnitID && errors.measuringUnitID}
                                                            name="measuringUnitID"
                                                            placeholder='--Select Measuring Unit--'
                                                            onBlur={handleBlur}
                                                            size='small'
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            value={skuDetails.measuringUnitID}
                                                            variant="outlined"
                                                            id="measuringUnitID"
                                                        >
                                                            <MenuItem value={0}>--Select Measuring Unit--</MenuItem>
                                                            {generateDropDownMenu(measuringUnitData)}
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="sKUMasterCode">
                                                            SKU Code *
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.sKUMasterCode && errors.sKUMasterCode)}
                                                            helperText={touched.sKUMasterCode && errors.sKUMasterCode}
                                                            fullWidth
                                                            size='small'
                                                            name="sKUMasterCode"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChangeNo(e)}
                                                            value={sKUMasterCode}
                                                            variant="outlined"
                                                            disabled={isUpdate}
                                                            inputProps={{
                                                                readOnly: true
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="sKUMasterName">
                                                            SKU Name *
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.sKUMasterName && errors.sKUMasterName)}
                                                            helperText={touched.sKUMasterName && errors.sKUMasterName}
                                                            fullWidth
                                                            size='small'
                                                            name="sKUMasterName"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={skuDetails.sKUMasterName}
                                                            variant="outlined"
                                                        />
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="sKUMasterDescription">
                                                            Description
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.sKUMasterDescription && errors.sKUMasterDescription)}
                                                            helperText={touched.sKUMasterDescription && errors.sKUMasterDescription}
                                                            fullWidth
                                                            size='small'
                                                            name="sKUMasterDescription"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={skuDetails.sKUMasterDescription}
                                                            variant="outlined"
                                                            inputRef={descriptionRef}
                                                        />
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="reOrderLevel">
                                                            Re-Order Level *
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.reOrderLevel && errors.reOrderLevel)}
                                                            fullWidth
                                                            helperText={touched.reOrderLevel && errors.reOrderLevel}
                                                            name="reOrderLevel"
                                                            onBlur={handleBlur}
                                                            size='small'
                                                            onChange={(e) => handleChangeForAmount(e)}
                                                            value={skuDetails.reOrderLevel}
                                                            variant="outlined"
                                                            inputRef={amountRef}
                                                            onKeyDown={(e) => handleKeyDown(e, descriptionRef)}
                                                            type="number"
                                                        >
                                                        </TextField>
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="maxLevel">
                                                            Max Level *
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.maxLevel && errors.maxLevel)}
                                                            helperText={touched.maxLevel && errors.maxLevel}
                                                            fullWidth
                                                            size='small'
                                                            name="maxLevel"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChangeForAmount(e)}
                                                            value={skuDetails.maxLevel}
                                                            variant="outlined"
                                                            inputRef={amountRef}
                                                            onKeyDown={(e) => handleKeyDown(e, descriptionRef)}
                                                            type="number"
                                                        />
                                                    </Grid>
                                                    <Grid item md={4} xs={12}>
                                                        <InputLabel shrink id="minLevel">
                                                            Min Level *
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.minLevel && errors.minLevel)}
                                                            helperText={touched.minLevel && errors.minLevel}
                                                            fullWidth
                                                            size='small'
                                                            name="minLevel"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChangeForAmount(e)}
                                                            value={skuDetails.minLevel}
                                                            variant="outlined"
                                                            inputRef={amountRef}
                                                            onKeyDown={(e) => handleKeyDown(e, descriptionRef)}
                                                            type="number"
                                                        />
                                                    </Grid>
                                                    <Grid container spacing={3} style={{ marginTop: '1rem', paddingLeft: '10px' }}>
                                                        <Grid item md={2} xs={12}>
                                                            <InputLabel shrink id="isActive">
                                                                Is Active
                                                            </InputLabel>
                                                            <Switch
                                                                checked={skuDetails.isActive}
                                                                onChange={handleChange}
                                                                name="isActive"
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid container justify="flex-end" spacing={3}>
                                                    {!isUpdate ?
                                                        <Box pr={2} style={{ marginTop: '20px' }}>
                                                            <Button
                                                                color="primary"
                                                                variant="outlined"
                                                                type="reset"
                                                                onClick={clearData}
                                                                size='small'
                                                            >
                                                                Clear
                                                            </Button>
                                                        </Box>
                                                        : null}
                                                    {!isUpdate ?
                                                        <Box pr={2} style={{ marginTop: '20px' }}>
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                type="submit"
                                                                size='small'
                                                            >
                                                                {"Add"}
                                                            </Button>
                                                        </Box>
                                                        : null}
                                                </Grid>
                                                {ArrayField.length > 0 ? (
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={3} style={{ marginLeft: '10px' }}>
                                                            <Typography color="textSecondary" gutterBottom>
                                                                <Chip
                                                                    style={{ marginLeft: '0', marginRight: '0', backgroundColor: "#FFFDD0", color: 'black', left: '0' }}
                                                                    icon={<AccessTimeIcon />}
                                                                    label={"Record Count: " + recordCount}
                                                                    clickable
                                                                    color="primary"
                                                                />
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                ) : null}
                                                {ArrayField.length > 0 ? (
                                                    <Grid item xs={12}>
                                                        <TableContainer>
                                                            <Table className={classes.table} aria-label="caption table">
                                                                <TableHead>
                                                                    <TableRow>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {ArrayField.map((row, index) => {
                                                                        return <TableRow key={index}>
                                                                        </TableRow>
                                                                    })}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                )
                                                    : null}
                                            </CardContent>
                                            {ArrayField.length > 0 ? (
                                                <Grid item xs={12}>
                                                    <TableContainer>
                                                        <Table className={classes.table} aria-label="caption table">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="left"><b>Account Code Name</b></TableCell>
                                                                    <TableCell align="left"><b>SKU Category</b></TableCell>
                                                                    <TableCell align="left"><b>Measuring Unit</b></TableCell>
                                                                    <TableCell align="left"><b>SKU Code</b></TableCell>
                                                                    <TableCell align="left"><b>SKU Name</b></TableCell>
                                                                    <TableCell align="left"><b>Description</b></TableCell>
                                                                    <TableCell align="right"><b>Re-Order Level</b></TableCell>
                                                                    <TableCell align="right"><b>Max Level</b></TableCell>
                                                                    <TableCell align="right"><b>Min Level</b></TableCell>
                                                                    <TableCell align="left"><b>Status</b></TableCell>
                                                                    <TableCell align="center"><b>Actions</b></TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {ArrayField.map((row, index) => {
                                                                    return <TableRow key={index}>
                                                                        <TableCell align="left" >{row.sKUTypeName}
                                                                        </TableCell>
                                                                        <TableCell align="left" >{row.sKUCategoryName}
                                                                        </TableCell>
                                                                        <TableCell align="left" >{row.measuringUnitName}
                                                                        </TableCell>
                                                                        <TableCell align="left" >{row.sKUMasterCode}
                                                                        </TableCell>
                                                                        <TableCell align="left" >{row.sKUMasterName}
                                                                        </TableCell>
                                                                        <TableCell align="left" >{row.sKUMasterDescription ? row.sKUMasterDescription : '-'}
                                                                        </TableCell>
                                                                        <TableCell align="right">
                                                                            {row.reOrderLevel !== null && row.reOrderLevel !== undefined
                                                                                ? row.reOrderLevel.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                                : '-'}
                                                                        </TableCell>
                                                                        <TableCell align="right">
                                                                            {row.maxLevel !== null && row.maxLevel !== undefined
                                                                                ? row.maxLevel.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                                : '-'}
                                                                        </TableCell>
                                                                        <TableCell align="right">
                                                                            {row.minLevel !== null && row.minLevel !== undefined
                                                                                ? row.minLevel.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                                                                : '-'}
                                                                        </TableCell>
                                                                        <TableCell align="left" >{row.isActive == true ? 'Active' : 'InActive'}
                                                                        </TableCell>
                                                                        <TableCell align='center' scope="row">
                                                                            <DeleteIcon
                                                                                style={{
                                                                                    color: "red",
                                                                                    marginBottom: "-1rem",
                                                                                    marginTop: "0rem",
                                                                                    cursor: "pointer"
                                                                                }}
                                                                                size="small"
                                                                                onClick={() => handleDeleteOpen(row, index)}
                                                                            >
                                                                            </DeleteIcon>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                })}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            )
                                                : null}
                                            {(ArrayField.length > 0 || isUpdate) ?
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="button"
                                                        variant="contained"
                                                        size="small"
                                                        onClick={() => handleAddOpen()}
                                                    >
                                                        {isUpdate ? "Update" : "Save"}
                                                    </Button>
                                                </Box>
                                                : null}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>

                </Container>

                <Dialog open={backConfirmation} onClose={handleDialogClose}>
                    <DialogTitle id="alert-dialog-slide-title">
                        <Typography
                            color="textSecondary"
                            gutterBottom
                            variant="h3">
                            <Box textAlign="center">
                                Confirmation
                            </Box>
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            <Typography variant="h5">Are you sure you want to go back?</Typography>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <br />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleDialogClose} color="primary" autoFocus>
                            No
                        </Button>
                        <Button onClick={handleConfirmBack} color="primary">
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={deleteConfirmation}>
                    <DialogTitle id="alert-dialog-delete">
                        <Typography
                            color="textSecondary"
                            gutterBottom
                            variant="h3">
                            <Box textAlign="center">
                                Confirmation
                            </Box>
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-delete-description">
                            <Typography variant="h5">Are you sure you want to delete this record?</Typography>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <br />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDeleteOnChange} color="primary" disabled={deleteYesDisable}
                        >
                            {deleteYesDisable ? <CircularProgress size="1.3rem" /> : 'Yes'}
                        </Button>
                        <Button
                            onClick={handleDelete} color="primary" autoFocus>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={addConfirmation}>
                    <DialogTitle id="alert-dialog-add">
                        <Typography
                            color="textSecondary"
                            gutterBottom
                            variant="h3">
                            <Box textAlign="center">
                                Confirmation
                            </Box>
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-add-description">
                            <Typography variant="h5">
                                {isUpdate
                                    ? "Are you sure you want to update this record?"
                                    : "Are you sure you want to save this record?"}
                            </Typography>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <br />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={handleAdd} color="primary" autoFocus>
                            No
                        </Button>
                        <Button onClick={handleAddOnChange} color="primary"
                            disabled={isProcessing}>
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
            </Page >
        </Fragment>
    )
}
